import { createRootRoute, Outlet } from '@tanstack/react-router'
import AuthProvider from '../components/AuthProvider'
import { TVNavigationProvider } from '../context/TVNavigationContext'

export const Route = createRootRoute({
  component: () => (
    <AuthProvider>
      <TVNavigationProvider>
      <Outlet />
      </TVNavigationProvider>
    </AuthProvider>
  ),
})
